module.exports = __webpack_public_path__ + "media/src/images/zu_05keep_rules02-9d992e013c9994ebd2ff5838ee31f2e8.gif";